export const GameMode = {
  Campaign: 'Campaign',
  Daily: 'Daily',
  Endless: 'Endless',
  Custom: 'Custom'
} as const;

export type GameMode = typeof GameMode[keyof typeof GameMode];

export const DifficultyProfile = {
  Easy: 'Easy',
  Normal: 'Normal',
  Hard: 'Hard'
} as const;

export type DifficultyProfile = typeof DifficultyProfile[keyof typeof DifficultyProfile];

export const PLATFORM_CONFIG = {
  platformName: 'Eternally Hub',
  version: '1.0.0',
};
